export default __webpack_public_path__ + "static/media/img-0789-portugal-half-face.71e35051.png";